import { BUTTON_VARIANT_CSS } from './button.constants';

/**
 * Returns a styled component from ./button.constants.
 * @param {string} variant
 * @param {object} theme
 * @returns {@emotion/react.css}
 */

export const cssForVariant = ({ variant, theme }) => BUTTON_VARIANT_CSS[variant](theme);
